var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "top" }, [
        _c("img", {
          staticClass: "title",
          attrs: { src: require("../../../static/images/tips/04_03.png") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "searchMark",
          attrs: { src: require("../../../static/images/tips/01_03.png") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "search",
          attrs: { src: require("../../../static/images/tips/02_07.png") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "appUi",
          attrs: { src: require("../../../static/images/tips/04_11.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }, [
        _c("img", {
          staticClass: "logoIcon",
          attrs: { src: require("../../../static/images/tips/03_11.png") }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-283f02c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283f02c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/miniUrl/tips.vue
// module id = null
// module chunks = 